<template>
	<div>
		<PageHeaderLayout :isBack="true">
			<div class="main-page-content">
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				></ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { tableColumns } from './config/registrationDetails.ts'

export default {
	name: 'RegistrationDetails',
	components: {
		PageHeaderLayout,
		ApeTable
	},
	data() {
		return {
			columns: tableColumns,
			loadingStaus: true,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			}
		}
	},
	methods: {
		switchPaging() {
			this.initList()
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs.apeTable.getPagingInfo(type)
			try {
				const res = await this.$api.getCourseRegistrationList({
					...pagingInfo,
					trainId: this.$route.query.id,
					status: 1
				})
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = list
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取报名详情失败')
			}
			this.loadingStaus = false
		}
	},
	mounted() {
		this.initList()
	}
}
</script>
